<template>
    <div class="report__content">
        <div class="wrapper patient__desc">
            <p>
                Formularz zgłoszenia przypadku składa się z kilku kroków. Szczegółowe informacje pomogą nam
                lepiej ocenić przypadek. Z edukacji można skorzystać niezależnie od ilości posiadanych
                informacji na temat pacjenta i jego choroby.
            </p>
            <p>
                Jeśli badania CT i MRI zawierają dane osobowe pacjenta, które umożliwią jego rozpoznanie
                (np. imię, nazwisko, PESEL) prosimy o pobranie
                <br />i podpisanie przez pacjenta zgody na
                przetwarzanie danych osobowych.
            </p>
            <a
                href="informacja dla pacjenta - przekazanie badań.pdf"
                target="_blank"
                class="btn btn--blue"
            >Pobierz zgodę</a>
        </div>
        <hr />
        <form class="wrapper patient__form">
            <h3 class="report__title">Dane pacjenta</h3>
            <div class="form__row form__row--center">
                <div class="form__col-1-6">
                    <h4 class="form__field-title">Wiek*</h4>
                    <input
                        type="number"
                        v-model="patientData.age"
                        min="0"
                        @blur="checkNegativeValue('age')"
                    />
                    <div v-if="errors.age" class="form__row-error">{{errors.age}}</div>
                </div>
                <div class="form__col-1-6">
                    <h4 class="form__field-title">Płeć*</h4>
                    <div class="form__label-group">
                        <label class="form__radio-label">
                            <input type="radio" v-model="patientData.sex" @change="errors.sex = ''" value="female" />
                            <div class="radio"></div>
                            <p>K</p>
                        </label>
                        <label class="form__radio-label">
                            <input type="radio" v-model="patientData.sex" @change="errors.sex = ''" value="male" />
                            <div class="radio"></div>
                            <p>M</p>
                        </label>
                    </div>
                    <div v-if="errors.sex" class="form__row-error">{{errors.sex}}</div>
                </div>
                <div class="form__col-1-6">
                    <h4 class="form__field-title">Waga*</h4>
                    <input
                        type="number"
                        v-model="patientData.weight"
                        min="0"
                        step="0.1"
                        placeholder="kg"
                        @blur="checkNegativeValue('weight')"
                    />
                    <div v-if="errors.weight" class="form__row-error">{{errors.weight}}</div>
                </div>
                <div class="form__col-1-6">
                    <h4 class="form__field-title">Wzrost*</h4>
                    <input
                        type="number"
                        v-model="patientData.height"
                        min="0"
                        step="1"
                        placeholder="cm"
                        @blur="checkNegativeValue('height')"
                    />
                    <div v-if="errors.height" class="form__row-error">{{errors.height}}</div>
                </div>
            </div>
            <div class="form__row form__row--center">
                <div class="form__col-1-3">
                    <h4 class="form__field-title">BMI</h4>
                    <input
                        type="number"
                        :value="calcBMI()"
                        disabled
                    />
                </div>
                <div class="form__col-1-3">
                    <h4 class="form__field-title">Zakładana objętość wątroby <small>[cm<sup>3</sup>]</small></h4>
                    <input
                        type="text"
                        :value="calcStandardLiverVolume()"
                        disabled
                    />
                </div>
            </div>
            <div class="form__row form__row--center">
                <a class="btn" @click="nextPage">Dalej</a>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: "Patient",
    data() {
        return {
            errors: {
                age: "",
                sex: "",
                weight: "",
                height: "",
            },
            patientData: {
                age: "",
                sex: "",
                weight: "",
                height: "",
            },
        };
    },
    methods: {

        calcBMI() {
            const { weight, height } = this.patientData;
            if (!weight || !height) return '';

            const BMI = parseFloat(weight / Math.pow(height / 100, 2)).toFixed(2);
            this.patientData.bmi = BMI;

            return BMI;
        },

        calcStandardLiverVolume() {
            const { weight, height } = this.patientData;
            if (!weight || !height) return '';

            const LiverVolume = parseFloat(1267.28 * (Math.sqrt( height * weight / 3600 )) - 794.41).toFixed(4);
            this.patientData.standardLiverVolume = LiverVolume;

            return LiverVolume;
        },

        nextPage() {

            if (this.validateFields()) {
                this.$store.commit("updatePatientData", this.patientData);
                this.$emit("next", 2);
            }

        },

        checkNegativeValue(field) {
            this.errors[field] = "";
            if (this.patientData[field] < 0) {
                this.errors[field] =
                    "Wartość tego pola nie może być mniejsza od zera";
            } else if (this.patientData[field] > 0 && field != "age") {
                this.patientData[field] = parseFloat(
                    this.patientData[field]
                ).toFixed(1);
            }
        },

        validateFields() {

            const fields = Object.keys(this.patientData);

            fields.map(field => this.checkIfNotEmpty(field));

            const errors = Object.values(this.errors);

            return !errors.filter(el => el != "").length;

        },

		checkIfNotEmpty(fieldName) {

            this.errors[fieldName] = "";
            if (!this.patientData[fieldName]) this.errors[fieldName] = "To pole jest wymagane";

        },
    },
};
</script>

<style lang="scss">
.patient {
    &__desc {
        text-align: center;
    }
    &__form {
        padding-bottom: 50px;
    }
}
</style>
